import { AxiosError } from 'axios'; // Import AxiosError for error typing
import { CAMPAIGN } from './mediaPlanning';
import { ApiResponse } from './types';
import { fetchData } from './utils';

export interface CheckPlanNameResponse {
  message: string;
}

export interface CheckPlanNameError {
  data: {
    status: string;
  };
}

export const checkPlanName = async (
  name: string
): Promise<ApiResponse<CheckPlanNameResponse>> => {
  try {
    return await fetchData<ApiResponse<CheckPlanNameResponse>>(
      `/${CAMPAIGN}/media-plans/campaign-name/availability?name=${encodeURIComponent(
        name
      )}`
    );
  } catch (error) {
    const axiosError = error as AxiosError<CheckPlanNameError>;
    if (axiosError.response) {
      throw axiosError.response;
    }
    throw new Error(`Failed to check campaign name: ${axiosError.message}`);
  }
};
